import React, { useEffect, useState, useMemo, useCallback } from "react";
import TableBackground from "../../components/TableBackground";
import { debounce } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../components/Pagination/Pagination";
import SearchComponent from "../../components/Search";
import { getPointAction } from "../../redux/Points/pointsActions";
import moment from "moment";
// import { useNavigate } from "react-router-dom";

const PointTable = ({ id }) => {
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const { pointLeaderboard, pointLeaderboardTotal, pointLeaderboardLoading } =
    useSelector((state) => state.points);

  // RETAIL PAGE CHANGE
  const onPageChange = (val) => {
    const { page } = val;
    setCurrentPage(page);
    dispatch(getPointAction({ id, page, value: searchValue }));
  };

  const handleSearch = useMemo(
    () =>
      debounce((val) => {
        dispatch(
          getPointAction({
            id,
            page: currentPage,
            value: val,
          })
        );
      }, 750),
    [dispatch, currentPage, id]
  );

  const handleChange = useCallback(
    (e) => {
      let val = e.target.value;
      setSearchValue(val);
      handleSearch(val);
    },
    [handleSearch]
  );

  useEffect(() => {
    dispatch(getPointAction({ id, page: currentPage, value: searchValue }));
  }, [dispatch, id, currentPage, searchValue]);

  return (
    <div>
      <TableBackground classname={"rounded-lg"}>
        <p className="text-primary font-semibold text-base leading-5 pt-4 px-4">
          Points Breakdown
        </p>

        {/* SEARCH AND FILTER SECTION */}
        <section className="flex gap-4  pt-4">
          <div className="w-full relative px-4">
            <SearchComponent
              placeholder="Search..."
              searchValue={searchValue}
              handleChange={handleChange}
            />
          </div>
        </section>

        <section className="mt-[30px] mb-[24px]">
          {pointLeaderboardLoading ? (
            <div className="animate-pulse w-full mt-4 px-4 pb-4 mb-4">
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full"></div>
            </div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th scope="col" className="px-4 pb-2">
                    Activity
                  </th>
                  <th scope="col" className="px-4 pb-2">
                    Amount
                  </th>
                  <th scope="col" className="px-4 pb-2">
                    Date
                  </th>
                  <th scope="col" className="px-4 pb-2">
                    Time
                  </th>
                  <th scope="col" className="px-4 pb-2">
                    Points
                  </th>
                  <th scope="col" className="px-4 pb-2">
                    Status
                  </th>
                </tr>
              </thead>

              <tbody>
                {pointLeaderboard?.pointActions?.map((data, index) => {
                  return (
                    <tr
                      key={index}
                      className="relative cursor-pointer hover:bg-[#edf7ee]"
                    >
                      <td className="px-4">{data.action || "N/A"}</td>
                      <td className="px-4">₦{data.spent_amount || "0"}</td>
                      <td className="px-4">
                        {moment(data.created).format("ll")}
                      </td>
                      <td className="px-4">
                        {" "}
                        {moment(data.created).format("LT")}
                      </td>
                      <td className="px-4">{data.point}</td>
                      <td className="px-4">
                        <div
                          className={
                            data.status === "debit"
                              ? "error-badge"
                              : data.status === "credit"
                              ? "success-badge"
                              : "na-badge"
                          }
                        >
                          <p>
                            {data.status === "debit"
                              ? "Debit"
                              : data.status === "credit"
                              ? "Credit"
                              : "Nill"}
                          </p>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}

          {!pointLeaderboardLoading && pointLeaderboard.length > 0 ? (
            <div className="mt-1">
              <PaginationComponent
                page={currentPage}
                onPageChange={(page) => onPageChange({ page })}
                pageSize={10}
                totalItems={pointLeaderboardTotal}
              />
            </div>
          ) : (
            ""
          )}
        </section>
      </TableBackground>
    </div>
  );
};

export default PointTable;
